<template>
  <div class="row">
    <div class="service">
      <div class="col-12">
        <div :style="'background:' + background_icon">
          <img
            :src="base_url + image"
            class="img_center">
        </div>
        <div class="service_name">{{ service_name }}</div>
        <div class="service_body my-2">
          <div
            class="service_body_description"
            v-html="data.description"/>
        </div>

        <div
          v-if="data.product_code === 'PT-DV-18'
            || data.product_code === 'PT-DV-3'
            || data.product_code === 'PT-DV-31'
            || data.product_code === 'PT-DV-32'
            || data.product_code === 'PT-DV-33'
            || data.product_code === 'PT-DV-20'
            || data.product_code === 'PT-DV-39'
            || data.product_code === 'PT-DV-60'
            || data.product_code === 'PT-DV-93'
            || data.product_code === 'PT-DV-94'
            || data.product_code === 'PT-DV-95'
            || data.product_code === 'PT-DV-96'
            || data.product_code === 'PT-DV-97'
          || data.product_code === 'PT-DV-62'">
          <div class="luan_giai service_body_description">Kết luận</div>
          <div
            class="content_result"
            v-html="data.content"/>
        </div>

        <div
          v-if="data.product_code === 'PT-DV-2'
          ">
          <div v-for="v in JSON.parse(data.content)">
            <div
              class="service_body_description"
              v-html="v"/>
          </div>
        </div>
        <div
          v-if="data.product_code === 'PT-DV-56'">
          <div
            v-for="a in data.gio_tot">
            <div
              v-html="a"/>
          </div>
          <br>
          <div
            v-html="data.an_mac"/>
          <br>
          <div
            v-html="data.tam_linh"/>
        </div>
        <div
          v-if="data.product_code === 'PT-DV-57'
          || data.product_code ==='PT-DV-59'">
          <div
            v-for="a in data.gio_tot">
            <div
              v-html="a"/>
          </div>
        </div>
        <div
          v-if="data.product_code === 'PT-DV-71'
            || data.product_code === 'PT-DV-74'
            || data.product_code === 'PT-DV-76'
            || data.product_code === 'PT-DV-77'
            || data.product_code === 'PT-DV-78'
            || data.product_code === 'PT-DV-63'
            || data.product_code === 'PT-DV-64'
            || data.product_code === 'PT-DV-68'
            || data.product_code === 'PT-DV-72'
          || data.product_code === 'PT-DV-80'">
          <div
            v-for="a in data.results">
            <h6><b>{{ a.mon }}</b></h6>
            <div
              v-for="c in a.content"
              class="mb-2">
              <p class="text-size-14"><span>-</span> <b>{{ c.sonar_day }}</b> - Ngày Âm lịch: {{ c.lunar_day }}</p>
            </div>
          </div>
          <div
            class="note"
            v-html="data.note"/>
        </div>

        <div
          v-if="data.product_code === 'PT-DV-86'
          || data.product_code === 'PT-DV-87'">
          <div
            class="text-size-14"
            v-html="data.content"/>
          <div
            v-for="a in data.results">
            <div class="luan_giai service_body_description">{{ a.mon }}</div>
            <div
              v-for="c in a.content"
              class="mb-2">
              <p class="text-size-14"><span>-</span> <b>{{ c.sonar_day }}</b> - Ngày Âm lịch: {{ c.lunar_day }}</p>
            </div>
          </div>
          <div
            class="note"
            v-html="data.note"/>
        </div>
        <div
          v-if="data.product_code === 'PT-DV-102'">
          <div v-if="data.xong_dat">
            <h6>1. Xông đất</h6>
            <div v-for="item in data.xong_dat">
              <p style="margin-left: 15px; font-size: 14px">- <b>{{ item }}</b></p>
            </div>
          </div>

          <div v-if="data.mo_hang">
            <h6>2. Mở hàng</h6>
            <div v-for="item in data.mo_hang">
              <p style="margin-left: 15px; font-size: 14px">- <b>{{ item }}</b></p>
            </div>
          </div>

          <div v-if="data.huong">
            <h6>3. Hướng</h6>
            <div v-for="item in data.huong">
              <p style="margin-left: 15px; font-size: 14px">- <b>Ngày: {{ item.ngay }}</b></p>
              <p style="margin-left: 15px; font-size: 14px">- <b>Hướng: {{ item.huong }}</b></p>
              <hr>
            </div>
          </div>
        </div>
      </div>
      <div
        v-if="data.vatpham.length > 0"
        class="my-card">
        <div class="header-card">
          <div class="header-card-left pull-left">Vật phẩm</div>
          <div class="header-card-right pull-right">
            <router-link to="/items">Xem thêm</router-link>
          </div>
          <div class="clearfix"/>
        </div>
        <div class="col-xs-12">
          <flickity
            v-if="products && products.length > 0"
            ref="flickity"
            :options="flickityOptions"
            class="flickity">
            <div
              v-for="item in products"
              class="card carousel-cell">
              <product-item :item="item"/>
            </div>
          </flickity>
        </div>
      </div>
    </div>

  </div>
</template>

<script>
  import ApiConfig from '../../communicate/ApiConfig'
  import {errorToaster} from '../../services/ErrorHandler'
  import rf from '../../communicate/RequestFactory'
  import ItemsService from '../item/ItemsService'
  import Flickity from 'vue-flickity'
  import ProductItem from "../categories/ProductItem";

  export default {
    name: 'ServiceResult',
    components: {ItemsService, Flickity, ProductItem},
    data() {
      return {
        data: {},
        base_url: ApiConfig.base_url,
        id: this.$route.params.id,
        image: '',
        service_name: '',
        background_icon: '',
        flickityOptions: {
          initialIndex: 4,
          prevNextButtons: false,
          pageDots: false,
          wrapAround: true,
          freeScroll: true,
          autoPlay: false
        },
        products: [],
        dv: 0
      }
    },

    mounted() {
      this.loadDetailService(this.id);
    },

    methods: {

      loadDetailService(service_id) {
        this.$Progress.start();
        rf.getRequest("ServiceRequest").getDetailService(service_id).then((res) => {
          this.$Progress.finish();
          if (res.status === 200) {
            this.service = res.data;
            this.service_name = this.service.name;
            this.image = this.service.image;
            this.background_icon = this.service.background_icon;
            this.loadResult();
          } else if (res.status === 401 || res.status === 403) {
            this.$router.push({path: `/login`});
          } else {
            errorToaster("Cố vấn phong thủy", res.message);
          }
        }).catch(err => {
          this.$Progress.fail();
          errorToaster("Cố vấn phong thủy", "Xảy ra lỗi kết nối");
        })
      },

      loadResult() {
        let result = localStorage.getItem("result_service");
        if (result) {
          this.data = JSON.parse(result);
          console.log(this.data)
          this.products = this.data.vatpham;
        } else {
          errorToaster("Cố vấn Phong thủy", "Xảy ra lỗi sin vui lòng thử lại");
          this.$router.push(this.$route.query.from || "/");
        }
      }
    }
  }
</script>

<style scoped>
  .fr_form {
    background-color: #efefef;
  }

  .img_center {
    display: block;
    margin-left: auto;
    margin-right: auto;
  }

  .content_service {
    display: flex;
    justify-content: center;
  }

  .note {
    font-style: italic;
    line-height: 20px;
    text-indent: 10px;
  }

  .card {
    margin-bottom: 10px;
    width: 100%;
    border-radius: unset;
    border: none;
  }

  ol, ul {
    margin-bottom: 0;
  }

  .carousel-cell {
    width: 50%;
    height: 400px;
    margin-right: 10px;
    background: white;
    border-radius: 5px;
  }

  .product-image {
    margin: 0px -15px;

  .carousel-cell-image {
    width: 100%;
    height: 260px;
    margin-right: 10px;
    background: white;
    border-radius: 5px;

  img {
    height: 100%;
    width: 100%;
    object-fit: fill;
  }

  }
  }

  @media screen and (max-width: 900px) {
    .line-rating div:nth-of-type(3) {
      flex-basis: 5%;
    }

    .line-rating div:nth-of-type(2) {
      flex-basis: 45%;
      margin-right: 10px;
    }

    .line-rating div:nth-of-type(1) {
      flex-basis: 30%;
    }

    .modal-container {
      width: 98%;
    }
  }

  .text-size-14 {
    font-size: 14px;
  }


  .content_result {
    text-indent: 10px;
  }

  .luan_giai {
    margin: 5px;
    font-style: italic;
    font-weight: bold;
    text-underline: auto;
    text-decoration: underline
  }

</style>



// WEBPACK FOOTER //
// src/components/service/ServiceResult.vue